function Logo() {
  return <span className="logo">📝 GoCheck ✅</span>;
}

export default Logo;
